import { BiPlus } from "react-icons/bi";
import ScrollableListItem from "./Components/ScrollableListItem/ScrollableListItem";
import { useState } from "react";

const ScrollableList = ({title, removeTitle, data, refresh, removeFunction, setShowAdd, listClass, customButtons, removeText}) => {
    const [search, setSearch] = useState("");

    const filter = (text) => {
        if(!Array.isArray(text)) {
            return text?.toLowerCase()?.includes(search.toLowerCase());
        }else{
            return text?.some(x => x?.toLowerCase()?.includes(search.toLowerCase()));
        }
    }

    const filteredData = data?.filter(x => filter(x.text));

    return (
        <>
            <div className="flex w-full justify-between mb-2">
                <h2>{title}</h2>
                <div className="flex gap-3">
                    { setShowAdd &&
                        <button onClick={() => setShowAdd(true)}>
                            <BiPlus className="btnIcon"/>
                        </button>
                    }
                    <input type="text" className="input" placeholder="Wyszukaj..." onChange={e => setSearch(e.target.value)}/>
                </div>
            </div>
            <div className={listClass}>
                { filteredData &&
                    <>
                        { filteredData.length == 0 &&
                            <h3 className="text-center">Brak danych...</h3>
                        }
                        { filteredData.map((item, index) => 
                            <ScrollableListItem removeText={removeText} removeTitle={removeTitle} customButtons={customButtons} removeFunction={removeFunction} key={`scrollItem_${title}_${index}`} data={item}/>
                        )}
                    </>
                }
                { !filteredData &&
                    <h3 className="text-center">Ładowanie danych...</h3>
                }
            </div>
        </>
    )
}

export default ScrollableList;